function sanitizeHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html;

  // Remove dangerous elements
  var dangerous = div.querySelectorAll('script,object,embed,form,input,textarea,button,select,meta,link,base');
  for (var i = 0; i < dangerous.length; i++) {
    dangerous[i].remove();
  }

  // Remove on* event handlers from all elements
  var all = div.querySelectorAll('*');
  for (var j = 0; j < all.length; j++) {
    var attrs = all[j].attributes;
    for (var k = attrs.length - 1; k >= 0; k--) {
      if (/^on/i.test(attrs[k].name)) {
        all[j].removeAttribute(attrs[k].name);
      }
    }
    // Restrict iframe src to https only
    if (all[j].tagName === 'IFRAME' && all[j].hasAttribute('src')) {
      if (!/^https:\/\//.test(all[j].getAttribute('src'))) {
        all[j].remove();
      }
    }
  }

  return { html: div.innerHTML, hasChanged: div.innerHTML !== html };
}

const editorConfig = {
  toolbar: {
    items: [
      'undo', 'redo',
      '|', 'heading',
      '|', 'bold', 'italic', 'underline', 'strikethrough',
           'subscript', 'superscript', 'code', 'removeFormat',
      '|', 'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight',
      '|', 'alignment',
      '|', 'numberedList', 'bulletedList', 'todoList',
           'outdent', 'indent',
      '|', 'link', 'insertImage', 'mediaEmbed', 'insertTable',
           'blockQuote', 'codeBlock', 'horizontalLine',
           'specialCharacters', 'pageBreak', 'htmlEmbed',
      '|', 'findAndReplace', 'showBlocks', 'sourceEditing',
    ],
  },
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
      { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
    ],
  },
  table: {
    contentToolbar: [
      'tableColumn', 'tableRow', 'mergeTableCells',
      'tableProperties', 'tableCellProperties', 'toggleTableCaption',
    ],
    tableProperties: {
      defaultProperties: {
        borderStyle: 'solid',
        borderWidth: '1px',
      },
    },
  },
  image: {
    toolbar: [
      'imageStyle:inline', 'imageStyle:block', 'imageStyle:side',
      '|', 'toggleImageCaption', 'imageTextAlternative',
      '|', 'linkImage',
      '|', 'resizeImage',
    ],
    resizeUnit: '%',
    resizeOptions: [
      { name: 'resizeImage:original', value: null, label: 'Original' },
      { name: 'resizeImage:25', value: '25', label: '25%' },
      { name: 'resizeImage:50', value: '50', label: '50%' },
      { name: 'resizeImage:75', value: '75', label: '75%' },
    ],
    insert: {
      type: 'auto',
    },
  },
  list: {
    properties: {
      styles: true,
      startIndex: true,
      reversed: true,
    },
  },
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      openInNewTab: {
        mode: 'manual',
        label: 'Open in a new tab',
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    },
  },
  htmlEmbed: {
    showPreviews: true,
    sanitizeHtml: sanitizeHtml,
  },
  htmlSupport: {
    allow: [
      {
        name: /^(div|span|p|br|hr|h[1-6]|ul|ol|li|a|img|figure|figcaption|table|thead|tbody|tr|th|td|caption|blockquote|pre|code|em|strong|u|s|sub|sup|dl|dt|dd|abbr|cite|mark|small|section|article|aside|details|summary|video|audio|source|picture)$/,
        attributes: {
          class: true,
          id: true,
          style: true,
          src: true,
          alt: true,
          href: true,
          target: true,
          rel: true,
          width: true,
          height: true,
          colspan: true,
          rowspan: true,
          controls: true,
          autoplay: true,
          loop: true,
          muted: true,
          title: true,
          type: true,
          start: true,
          reversed: true,
          'data-.*': true,
        },
        classes: true,
        styles: true,
      },
      {
        name: 'iframe',
        attributes: {
          src: /^https:\/\//,
          width: true,
          height: true,
          frameborder: true,
          allow: true,
          allowfullscreen: true,
          title: true,
          style: true,
        },
        classes: true,
        styles: true,
      },
    ],
    disallow: [
      {
        name: /^(script|object|embed|form|input|textarea|button|select|meta|link|base)$/,
      },
      {
        name: /.*/,
        attributes: /^on/,
      },
    ],
  },
};

export default editorConfig;
